import { RecruitmentTypeService } from './recruitment-type.service';
const service = new RecruitmentTypeService();

export interface RecruitmentTypeState {
   recruitmentTypes: Array<any>;
}

const state = {
   recruitmentTypes: [],
};

const getters = {
   recruitmentTypes(state: any) {
      return state.recruitmentTypes;
   },
};

const mutations = {
   setRecruitmentTypes(state: any, newValue: any) {
      state.recruitmentTypes = newValue;
   },
};

const actions = {
   async getRecruitmentTypes(context: any) {
      return await service.getRecruitmentTypes().then((response) => {
         context.commit('setRecruitmentTypes', response);
         return response;
      });
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
